import { parseISOString } from './parseISOString'

export function formatDateTimeStringTimeOnly(value: string | null) {
  if (value === null) {
    return value
  }

  if (!value) {
    return undefined
  }

  return parseISOString(value).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })
}
